import { createContext, useContext } from "react";
import { useTheme } from "@mui/material";
import { AdminLook, Look, LOOKS, LookTokens } from "./looks";

/** The platform look as React context — kept apart from `LookProvider` (which fetches) so screens import no API code. */
type LookContextValue = {
  look: AdminLook;
  /** false on an older backend (GET 404): no «Админы загвар» screen. */
  settingAvailable: boolean;
  /** PUT, then apply for this person; throws (and keeps the old look) on failure. */
  setLook(look: AdminLook): Promise<void>;
};

export const LookContext = createContext<LookContextValue>({
  look: "classic",
  settingAvailable: false,
  setLook: async () => {},
});

export const useAdminLook = (): LookContextValue => useContext(LookContext);

/** The active look and its tokens in this person's mode, for screens drawn on the look directly. */
export function useLookTokens(): { look: Look; t: LookTokens } {
  const { look } = useAdminLook();
  const mode = useTheme().palette.mode;
  return { look: LOOKS[look], t: LOOKS[look][mode] };
}

